import { translate } from 'i18n/i18n'
import { useMemo } from 'react'
import { CommentTextarea } from '../CommentTextarea'
import { buildSoilChartData } from './_utils/buildSoilChartData'
import { SoilZoneCharts } from './SoilZoneCharts'
import type { SoilProps } from './types'

export const Soil = ({ resetKey, data }: SoilProps) => {
  const {
    selectedProperty,
    timezone,
    lngLats,
    soilDateFrom,
    soilDateTo,
    soilData: soilDataValues,
    precipitationStationLngLat,
  } = data

  const chartContent = useMemo(
    () =>
      buildSoilChartData({
        lngLats,
        selectedProperty,
        soilData: soilDataValues,
        precipitationStationLngLat,
        timezone,
      }),
    [lngLats, selectedProperty, soilDataValues, precipitationStationLngLat, timezone],
  )

  return (
    <div>
      <h3>{translate.phrases.banyanApp('Soil Moisture & Infiltration')}</h3>
      {chartContent.map(({ awcChart, awcHeatmap, intervalsForChart, soilStationFavoriteDepths, title }) => {
        return (
          <SoilZoneCharts
            key={title}
            title={title}
            awcChart={awcChart}
            awcHeatmap={awcHeatmap}
            intervalsForChart={intervalsForChart}
            soilStationFavoriteDepths={soilStationFavoriteDepths}
            soilDateFrom={soilDateFrom}
            soilDateTo={soilDateTo}
            timezone={timezone}
            selectedProperty={selectedProperty}
          />
        )
      })}
      <CommentTextarea resetKey={resetKey} />
    </div>
  )
}
